/**
 * Created by Jerker Nord on 2020-01-09.
 */
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";

export class BonusBunniesBetlineEvent extends BetLineEvent {
    public static readonly SHOW_WIN_BET_LINE_WINS:string = "betLineEvent_showBetLineWinWinAmount";
}